@if (ancestorOrgs) {
  <se-fe-card>
    <se-fe-card-header
      seFeDataTitle="Affiliation Access"
      [seFeDataHeavyBorder]="true">
    </se-fe-card-header>
    <se-fe-card-content>
      @if (!loaded) {
        <se-fe-spinner [seFeDataCenter]="true" [seFeDataSize]="900"></se-fe-spinner>
      }
      @if (loaded) {
        <se-fe-list>
          @for (org of ancestorOrgs; track org) {
            <se-fe-list-item>
              <se-fe-header class="affiliation-access__header" [seFeDataSize]="500">
                <div seFeHeaderTitle class="org-title">
                  <span class="cut-off-text" [seFeTooltipTrigger]="org.name?.length > 6 ? orgNameTooltip : null">{{ org.name }}</span>
                  <se-fe-tooltip #orgNameTooltip>{{ org.name }}</se-fe-tooltip>
                </div>
                <se-fe-avatar
                  seFeHeaderVisual
                  seFeDataType="org"
                  [seFeDataIdentity]="org.name"
                  [seFeDataImgUrl]="org.logo?.medium_logo_url"
                  seFeDataSize="200">
                </se-fe-avatar>
                <se-fe-switch
                  class="tight"
                  seFeHeaderActions
                  seFeRightInput
                  [seFeDataChecked]="!!org.topDownAccessRole"
                  [seFeDataIsLoading]="org.loading"
                  (seFeChange)="toggleTopDownAccess($event, org)">
                </se-fe-switch>
              </se-fe-header>
            </se-fe-list-item>
          }
        </se-fe-list>
      }
    </se-fe-card-content>
  </se-fe-card>
}
<se-fe-toast></se-fe-toast>
